/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-01-06 17:37:00
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer, PageResDo } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { type } from 'os';
export declare namespace CameraAlarmDOI {
    export interface RowDataI {
        create_time: string;
        id: number;
        name: string;
        ip: string;
        img: string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        name?: string;
    }
}

export default class CameraAlarmApi {
    /**
     * 查询列表
     */
    static async searchList(params: CameraAlarmDOI.QueryRowDataParamsI): Promise<ResultPageDo<CameraAlarmDOI.RowDataI[]>> {
       return Api.post('/monitor/hunan/alarm_value/get', {
            name: '',
            ...params,
        });
    }
}
